import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';
import { RegexTriggerElement as RegexTriggerElementModel } from '../../../../models/ConversationHistory/HistoryElement/TriggerHistoryElement/RegexTriggerElement';
import BaseHistoryElement from '../BaseHistoryElement';
import rootStore from '../../../../stores/rootStore';
import { useGetIcon } from '../../../customHooks/useGetIcon';

interface IProps {
  element: RegexTriggerElementModel;
}

const RegexTriggerElement: React.FC<IProps> = ({ element }: IProps) => {
  const getIcon = useGetIcon();
  const { blockStore } = useContext(rootStore);
  const block = blockStore?.allBlocks?.find(block => block?.trigger?.id === element.triggerId);

  return (
    <BaseHistoryElement element={element} title='Regex Trigger evaluated' icon={getIcon('regex_trigger')}>
      {element.triggered ? (
        <div className='card-paragraph'>
          <i className={getIcon('check')}> </i>
          <span> Triggered block "{block?.title}" </span>
        </div>
      ) : (
        <div className='card-paragraph'>
          <i className={getIcon('error')}> </i>
          <span> Not triggered block "{block?.title}" </span>
        </div>
      )}
    </BaseHistoryElement>
  );
};

export default observer(RegexTriggerElement);
